<template>
    <div class="SideMenu-MAIN"> <!--:style="`background-color: ${getColor(color).bg};`"-->

        <!--<img :src="require(`../assets/menu-pfp.png`)">
        <h2>{{ name }}</h2>
        <p></p>-->

        <div @click="setView('home')" :class="viewParam == 'home' ? 'SideMenu-marked' : ''"><img :src="require(`../assets/menu-inicio.png`)"></div>
        <div @click="setView('descuentos')" :class="viewParam == 'descuentos' ? 'SideMenu-marked' : ''"><img :src="require(`../assets/menu-descuentos.png`)"></div>
        <div @click="setView('categorias')" :class="viewParam == 'categorias' ? 'SideMenu-marked' : ''"><img :src="require(`../assets/menu-categorias.png`)"></div>
        <div @click="setView('flashmania')" :class="viewParam == 'flashmania' ? 'SideMenu-marked' : ''"><img :src="require(`../assets/menu-flashmania.png`)"></div>
        <div @click="setView('historial')" :class="viewParam == 'historial' ? 'SideMenu-marked' : ''"><img :src="require(`../assets/menu-historial.png`)"></div>
        <div @click="setView('cerca')" :class="viewParam == 'cerca' ? 'SideMenu-marked' : ''"><img :src="require(`../assets/menu-cerca.png`)"></div>

        <img src="../assets/close-btn.png" class="close-btn" @click="closeSideMenu()"/>

    </div>
</template>

<script>
export default {
    name: 'SideMenu',
    data(){
        return{
            m: '',
            name: '',
            viewParam: '',
            TEST: localStorage.getItem("m_usuario") == "XMZ9238" || localStorage.getItem("m_usuario") == "XMF1024",
        }
    },
    methods: {
        closeSideMenu(){
            this.$parent.sideMenuActive = false;
        },

        getFrontURL(){
			return window.location.origin;
		},

        setView(view_){
            if(!view_ || view_ == "") return;

            window.location.href = this.getFrontURL() + "/" + view_;  
        }
    },
    mounted(){
        const userData = JSON.parse(localStorage.getItem("userData"));
        this.m = userData.m;
        this.name = userData.sobrenombre;

        let params = new URLSearchParams(document.location.search);
        this.viewParam = params.get("view");
    }
}
</script>

<style scoped>
.SideMenu-MAIN{
    position: fixed;
    left: 0;
    top: 10ch;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: 'Benton Sans BBVA Bold';
    border-radius: 0 2ch 0 2ch;
    padding: 2ch;
    padding-bottom: 0;
    width: 6ch;
    background-color: #DFEEFF;
    z-index: 2;
}

.SideMenu-MAIN > img:not(.close-btn){
    width: 2.5ch;
    margin-top: 0.5ch;
}

.SideMenu-MAIN > h2{
    font-size: 1.25ch;
    margin-bottom: 0;
    max-width: 8ch;
    text-align: center;
    color: #051283;
}

.SideMenu-MAIN > p{
    font-family: 'Benton Sans BBVA Book';
    font-size: 1ch;
    border-radius: 0.5ch;
    padding: 0.25ch 0.5ch;
    background-color: rgba(255, 255, 255, 0.9);
    margin-top: 0.25ch;
    margin-bottom: 2.5ch;
}

.SideMenu-MAIN > div{
    width: calc(100% + 4ch);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0.5ch 0;
    border-radius: 0 0 1.5ch 0;
}

.SideMenu-MAIN > div:hover{
    cursor: pointer;
    background-color: #CBE3FB;
    transition: all 0.3s;
}

.SideMenu-marked{
    background-color: #CBE3FB;
}

.close-btn{
    position: absolute;
    top: -0.5ch;
    right: -0.5ch;
    width: 2ch;
}

.close-btn:hover{
    cursor: pointer;
    scale: 1.05;
}

.SideMenu-MAIN > div img{
    height: 4.5ch;
    margin-bottom: 0.25ch;
}

.SideMenu-MAIN > div:nth-child(4) > img{ scale: 0.85; }
.SideMenu-MAIN > div:nth-child(5) > img{ scale: 0.6; }
.SideMenu-MAIN > div:nth-child(6) > img{ scale: 0.8; }
.SideMenu-MAIN > div:nth-child(7) > img{ scale: 0.84; }
.SideMenu-MAIN > div:nth-child(8) > img{ scale: 0.7; }
.SideMenu-MAIN > div:nth-child(9) > img{ scale: 0.7; }
</style>